import { useState, useEffect, useRef } from "react";
import Projects from "../components/Projects";
import todoAgro from "../assets/images/todoagro.png"
import agrocarteira from "../assets/images/agrocarteira.png"
import almotick from "../assets/images/almotick.png"
import chipau from "../assets/images/chipau.png"
const ProjectsContainer = () => {
    const [isVisible, setIsVisible] = useState(false);
    const projectsRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (projectsRef.current) {
            observer.observe(projectsRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (

        <>
            <div class="wave-top1" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" class="wave-top2"><path d="M-0.00,49.98 C150.00,149.99 271.49,-49.98 500.00,49.98 L500.00,-0.00 L-0.00,-0.00 Z" class="wave-top3"></path></svg></div>
            <div class="wave-bottom1" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" class="wave-bottom2"><path d="M-0.00,49.98 C150.00,149.99 271.49,-49.98 500.00,49.98 L500.00,-0.00 L-0.00,-0.00 Z" class="wave-bottom3"></path></svg></div>
            <div className="ps-5 pt-0 pe-5 pb-5 m-0 skills-component" ref={projectsRef} >
                <h3 id="projects" className="text-uppercase title text-center mb-4">Experiencia</h3>
                <p className="text-center w-75 mx-auto text-light">En esta sección muestro los <span className="fw-bold text-warning">proyectos más destacados</span> y completos en los que he trabajado.
                    En cada uno de ellos lideré y colaboré en el desarrollo de la aplicación web y mobile. <br />
                    En ellos apliqué tecnologías como <span className="fw-bold text-warning"> Redux, Axios, Typescript </span>, patrones de diseño como <span className="fw-bold text-warning"> MVC, Repository </span> y patrones de arquitectura como <span className="fw-bold text-warning"> Clean Architecture </span>.
                </p>
                <div className="row">
                    <div className={`col-md-6 mb-5 d-flex flex-column justify-content-center align-items-center ${isVisible ? 'fade-in' : ''}`} style={{ animationDelay: '0.4s', visibility: isVisible ? 'visible' : 'hidden' }}>
                        <Projects title={'Almotick'} description={'Aplicación web para la gestión de eventos y venta de entradas, con una interfaz moderna y responsiva. Desarrollado con React y TypeScript. Desarrollado con React, Vite y TypeScript, siguiendo una arquitectura limpia'} url={'https://almotick.com'} img={almotick} />
                    </div>
                    <div className={`col-md-6 mb-5 d-flex flex-column justify-content-center align-items-center ${isVisible ? 'fade-in' : ''}`} style={{ animationDelay: '0.2s', visibility: isVisible ? 'visible' : 'hidden' }}>
                        <Projects title={'TodoAgro'} description={`Marketplace transaccional 100% dedicado al agronegocio brasilero. \n Web desarrollada con React, Vite y Typescript. \n Aplicación móvil desarrollada con React Native, Expo y Typescript`} url={'https://todoagro.com.br'} img={todoAgro} />
                    </div>
                    <div className={`col-md-6 mb-5 d-flex flex-column justify-content-center align-items-center ${isVisible ? 'fade-in' : ''}`} style={{ animationDelay: '0.4s', visibility: isVisible ? 'visible' : 'hidden' }}>
                        <Projects title={'AgroCarteira'} description={'Billetera oficial de TodoAgro, permite gestionar pagos, enviar y recibir dinero de forma segura. \n Web desarrollada con React, Vite y Typescript. \n Aplicación móvil desarrollada con React Native, Expo y Typescript'} url={'https://agrocarteira.com.br'} img={agrocarteira} />
                    </div>
                    <div className={`col-md-6 mb-5 d-flex flex-column justify-content-center align-items-center ${isVisible ? 'fade-in' : ''}`} style={{ animationDelay: '0.4s', visibility: isVisible ? 'visible' : 'hidden' }}>
                        <Projects title={'ChipauApp'} description={'Aplicación web para la gestión de pedidos de un reconocido local de comidas en la ciudad de Corrientes. \n Web desarrollada con React, Vite y Typescript.'} url={'https://649f7ab26243bb5e8d40b18e--dulcet-licorice-352226.netlify.app'} img={chipau} />
                    </div>
                </div>

            </div>
        </>

    )
}

export default ProjectsContainer;